import $ from 'jquery'
import Swal from 'sweetalert2'

export default {
  init() {
    $('.contact-form').on( 'submit', function( event ) {

      event.preventDefault();

      const t = $(this);

      t.find('.mimo-button').addClass('is-loading');

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: JWD.ajaxurl,
        data: t.serialize(),
        success : function( data ){

          t.find('.mimo-button').removeClass('is-loading');
          t.find('.form-group').removeClass('has-error').find('em').remove();

          if (data.errors === true) {

            if ( data.name ) $( '#contact-firstname' ).closest('.form-group').addClass('has-error').append('<em>' + data.name + '</em>');
            if ( data.phone ) $( '#contact-phone' ).closest('.form-group').addClass('has-error').append('<em>' + data.phone + '</em>');
            if ( data.email ) $( '#contact-email' ).closest('.form-group').addClass('has-error').append('<em>' + data.email + '</em>');

            $('html, body').animate({

              scrollTop: t.find('.has-error').offset().top -120

            },800, 'easeOutQuart');

          }else{

            t.find('.form-control').val('');

            Swal.fire({
              title: data.msg,
              html: data.msg_description,
              icon: 'success',
              confirmButtonText: "ตกลง",
              confirmButtonColor: "#000",
            })

          }

        },
        complete: function(data){},
        error : function( err ){}

      });

    });
  },
  finalize() {
  },
}